// react
import { useState } from 'react';

// types
import { LoadingStatus } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormEditDocument } from '../../forms/FormEditDocument/FormEditDocument';

// props
export interface DialogEditDocumentProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogEditDocument = ({ isOpen, onClose, onSuccess }: DialogEditDocumentProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [status, setStatus] = useState<LoadingStatus>('DEFAULT');

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('saveDocument'),
					loading: status === 'LOADING',
					form: 'form-edit-document',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={400}
			onClose={onClose}
			title={{
				children: t('editDocument'),
				variant: 'h3',
			}}>
			<FormEditDocument onClose={onClose} onSuccess={onSuccess} setStatus={setStatus} />
		</DialogActions>
	);
};
